import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Table } from "reactstrap";
import { heater_type_types } from "helpers/listsHardcodedData";
import * as endpoints from "constants/endpoints";
import { GetData } from "../../helpers/CRUD.js";
import { str2bool } from "../../helpers/utils.js";
import i18next from "i18next";

const TableHeaterType = (props) => {
  const [state, setState] = useState({
    equipmentManufacturers: [],
  });

  const handleDataChange = (event) => {
    const value = event.target.value;

    setState((state) => ({
      ...state,
      [event.target.name]: value,
    }));

    props.data[event.target.name] = value;
  };

  const handleEdit = () => {
    setState((state) => ({ ...state, mode: "edit" }));
  };

  const handleSave = () => {
    setState((state) => ({ ...state, mode: "view" }));
  };

  const toggleActive = (e) => {
    setState((state) => ({ ...state, isActive: str2bool(e.target.value) }));

    props.data.isActive = str2bool(e.target.value);
  };

  const getNomEquipmentManufacturers = () => {
    const url = `${endpoints.NOMENCLATURE_ENDPOINT}/EquipmentManufacturer/GetAllByDeviceType?deviceType=Отоплителни тела`;

    GetData(
      url,
      (data) => {
        setState((state) => ({ ...state, equipmentManufacturers: data }));
      },
      (error) => console.log(error)
    );
  };

  useEffect(() => {
    setState((state) => ({ ...state, ...props.data }));
    getNomEquipmentManufacturers();
  }, []);

  const radioStyle = {
    listStyle: "none",
    paddingLeft: "0",
  };
  const labelStyle = {
    paddingLeft: "20px",
  };

  const tableStyle = {
    tableLayout: "fixed",
  };

  const {
    id,
    name,
    type,
    equipmentManufacturerId,
    equipmentManufacturer,
    size1,
    size2,
    size3,
    pow,
    kSK1,
    kSK2,
    kSK3,
    kSK4,
  } = props.data;

  const heater_type_types_list = heater_type_types();

  return (
    <>
      <div className="table-responsive">
        <Table className="table-nowrap mb-0" style={tableStyle}>
          <tbody>
            <tr>
              <th>{i18next.t("name")}</th>

              <td>{name}</td>
            </tr>

            <tr>
              <th>{i18next.t("label-heater-type")}</th>

              <td>
                {props.mode === "edit" ? (
                  <select
                    name="type"
                    id="heater_type_type"
                    onChange={(e) => handleDataChange(e)}
                    value={type}
                    className="w-100 input-styled"
                  >
                    <option value="0" selected={type === "" ? true : false}>
                      {i18next.t("select_heater_type")}
                    </option>
                    {heater_type_types_list &&
                      heater_type_types_list.length > 0 &&
                      heater_type_types_list.map((type) => (
                        <option
                          value={type.key}
                          selected={type === type.key ? true : false}
                        >
                          {type.value}
                        </option>
                      ))}
                  </select>
                ) : (
                  type
                )}
              </td>
            </tr>

            <tr>
              <th>{i18next.t("manufacture")}</th>

              <td>
                {props.mode === "edit" ? (
                  <select
                    name="equipmentManufacturerId"
                    id="heater_type_еquipment_manufacturer"
                    onChange={(e) => handleDataChange(e)}
                    value={equipmentManufacturerId}
                    className="w-100 input-styled"
                  >
                    <option
                      value="0"
                      selected={
                        state.equipmentManufacturerId === "" ? true : false
                      }
                    >
                      {i18next.t("select_equipment_manufacturer")}
                    </option>
                    {state.equipmentManufacturers &&
                      state.equipmentManufacturers.length > 0 &&
                      state.equipmentManufacturers.map(
                        (еquipmentManufacturer) => (
                          <option
                            key={`option-${еquipmentManufacturer.id}`}
                            value={еquipmentManufacturer.id}
                            selected={
                              state.equipmentManufacturerId ===
                              еquipmentManufacturer.id
                                ? true
                                : false
                            }
                          >
                            {еquipmentManufacturer.name}
                          </option>
                        )
                      )}
                  </select>
                ) : (
                  props.data.equipmentManufacturer &&
                  props.data.equipmentManufacturer.name
                )}
              </td>
            </tr>

            <tr>
              <th>{i18next.t("power")}</th>

              <td>
                {props.mode === "edit" ? (
                  <input
                    name="pow"
                    type="number"
                    step={0.1}
                    min={0}
                    placeholder={i18next.t("placeholder_enter_power")}
                    id="heater_type_pow"
                    onChange={(e) => handleDataChange(e)}
                    defaultValue={pow}
                    className="w-100 input-styled"
                  />
                ) : (
                  pow
                )}
              </td>
            </tr>

            <tr>
              <th>{i18next.t("KcHF")}</th>

              <td>
                {props.mode === "edit" ? (
                  <input
                    name="kSK1"
                    type="number"
                    step={0.1}
                    min={0}
                    placeholder={i18next.t("placeholder_enter_size")}
                    id="heater_type_kSK1"
                    onChange={(e) => handleDataChange(e)}
                    defaultValue={kSK1}
                    className="w-100 input-styled"
                  />
                ) : (
                  kSK1
                )}
              </td>
            </tr>

            <tr>
              <th>{i18next.t("KcHF1")}</th>

              <td>
                {props.mode === "edit" ? (
                  <input
                    name="kSK2"
                    type="number"
                    step={0.1}
                    min={0}
                    placeholder={i18next.t("placeholder_enter_size")}
                    id="heater_type_kSK2"
                    onChange={(e) => handleDataChange(e)}
                    defaultValue={kSK2}
                    className="w-100 input-styled"
                  />
                ) : (
                  kSK2
                )}
              </td>
            </tr>

            <tr>
              <th>{i18next.t("KcHF2")}</th>

              <td>
                {props.mode === "edit" ? (
                  <input
                    name="kSK3"
                    type="number"
                    step={0.1}
                    min={0}
                    placeholder={i18next.t("placeholder_enter_size")}
                    id="heater_type_kSK3"
                    onChange={(e) => handleDataChange(e)}
                    defaultValue={kSK3}
                    className="w-100 input-styled"
                  />
                ) : (
                  kSK3
                )}
              </td>
            </tr>

            <tr>
              <th>{i18next.t("KcHF3")}</th>

              <td>
                {props.mode === "edit" ? (
                  <input
                    name="kSK4"
                    type="number"
                    step={0.1}
                    min={0}
                    placeholder={i18next.t("placeholder_enter_size")}
                    id="heater_type_kSK4"
                    onChange={(e) => handleDataChange(e)}
                    defaultValue={kSK4}
                    className="w-100 input-styled"
                  />
                ) : (
                  kSK4
                )}
              </td>
            </tr>

            <tr>
              <th>Size 1</th>

              <td>
                {props.mode === "edit" ? (
                  <input
                    name="size1"
                    placeholder={i18next.t("placeholder_enter_size")}
                    id="heater_type_size1"
                    onChange={(e) => handleDataChange(e)}
                    defaultValue={size1}
                    className="w-100 input-styled"
                  />
                ) : (
                  size1
                )}
              </td>
            </tr>

            <tr>
              <th>Size 2</th>

              <td>
                {props.mode === "edit" ? (
                  <input
                    name="size2"
                    type="number"
                    step={1}
                    min={0}
                    placeholder={i18next.t("placeholder_enter_size")}
                    id="heater_type_size2"
                    onChange={(e) => handleDataChange(e)}
                    defaultValue={size2}
                    className="w-100 input-styled"
                  />
                ) : (
                  size2
                )}
              </td>
            </tr>

            <tr>
              <th>Size 3</th>

              <td>
                {props.mode === "edit" ? (
                  <input
                    name="size3"
                    type="number"
                    step={1}
                    min={0}
                    placeholder={i18next.t("placeholder_enter_size")}
                    id="heater_type_size3"
                    onChange={(e) => handleDataChange(e)}
                    defaultValue={size3}
                    className="w-100 input-styled"
                  />
                ) : (
                  size3
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
};

TableHeaterType.propTypes = {
  userProfile: PropTypes.any,
  onGetUserProfile: PropTypes.func,
};

const mapStateToProps = ({ contacts }) => ({
  userProfile: contacts.userProfile,
});

const mapDispatchToProps = (dispatch) => ({
  onGetUserProfile: () => dispatch(getUserProfile()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TableHeaterType));
